import React, { PureComponent } from "react";

import { TTP_API_URL } from "Config";
import classnames from "classnames";
//import SocialContainer from "../Social/SocialContainer";

import styles from "./Media.local.scss";
import { getDateLabel, addLandaSize, userHasRights } from "Utils";
import _ from "i18n";
import { check } from "optimist";

export default class MediaComponent extends PureComponent {
  state = {
    play: false
  };

  render() {
    const {
      language,
      media,
      openMediaReveal,
      checks,
      auth,
      editor,
      openMediaEditor
    } = this.props;
    const {
      preview,
      fullMediaUrl,
      webPath,
      createdAt,
      docType,
      mediaStatus
    } = media;

    const titleAttr = `title${language.charAt(0).toUpperCase() +
      language.slice(1)}`;

    let path = null;
    if (
      docType === "VIDEO" &&
      preview &&
      (preview.fullMediaUrl || preview.webPath)
    ) {
      path = preview.fullMediaUrl
        ? preview.fullMediaUrl
        : TTP_API_URL + "/" + preview.webPath;
    } else if (docType === "IMAGE") {
      path = fullMediaUrl ? fullMediaUrl : TTP_API_URL + "/" + webPath;
    }
    path = path ? addLandaSize(path, 280) : "/img/no-image.png";
    return (
      <div
        className={
          checks.map(media => media.id).includes(media.id)
            ? styles.media + " " + styles.checked
            : styles.media
        }
        onClick={openMediaReveal}
      >
        {mediaStatus === "MASKED" ? (
          <span className={styles.masked}>
            <i className="icon-eye" />
          </span>
        ) : null}
        {docType === "PPT" || docType === "PDF" ? (
          <div className={styles.docs}>
            <img src={`/img/${docType.toLowerCase()}.png`} alt="" />
            <div className={styles.docInfo}>
              <h3>{media[titleAttr]}</h3>
              <span className={styles.date}>
                {getDateLabel(createdAt, false)}
              </span>
            </div>
          </div>
        ) : (
          <div
            className={styles.mediaContent}
            style={{ backgroundImage: `url(${path})` }}
          >
            {docType === "VIDEO" ? (
              <div className={styles.play}>
                <img src="/img/play.png" alt="" style={{ width: "40px" }} />
              </div>
            ) : null}
          </div>
        )}
        <div className={styles.overlay}>
          {userHasRights(auth, media) &&
            !editor && (
              <div className={styles.groupAction}>
                <div className={styles.editMedia}>
                  <button onClick={openMediaEditor}>
                    <span className={classnames(styles.icon, "icotam-edit")} />
                    <span className={styles.label}>{_("Edit the media")}</span>
                  </button>
                </div>
                <div className={styles.addToAlbum}>
                  <button onClick={this.props.handleClickSelect}>
                    <span className={styles.label}>{_("Select media")}</span>
                    <span className={styles.check} />
                  </button>
                </div>
              </div>
            )}

          {editor && (
            <div className={styles.groupAction}>
              <div className={styles.editMedia}>
                <button onClick={this.props.deleteMediaFromEditor}>
                  <span className={classnames(styles.icon, "icotam-close")} />
                  <span className={styles.label}>{_("Remove")}</span>
                </button>
              </div>
            </div>
          )}

          <div className={styles.infos}>
            <span className={styles.date}>
              {getDateLabel(createdAt, false)}
            </span>
            <h3>{media[titleAttr]}</h3>
          </div>
        </div>
      </div>
    );
  }
}

// Conn



// WEBPACK FOOTER //
// ./src/components/Common/Media/MediaComponent.js